import React from "react";
import Flex from "./Flex";
import styled from "styled-components";

const FlexBetween = styled(Flex)`
  justify-content: space-between;
`;

export default FlexBetween;
